import React, { useState, useCallback } from 'react';
import * as PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { renderToString } from 'react-dom/server';
import Swal from 'sweetalert2';
import authActions from '../../store/actions/authActions';
import Input from '../UI/Input';
import Preloader from '../UI/Preloader';
import helpers from '../../helpers/helpers';

const AuthSidebarSignUp = ({ toggleSidebar, closeAuthSidebar }) => {
  const dispatch = useDispatch();
  const [emailValue, handleEmailValue] = useState();
  const [isLoading, setLoading] = useState(false);

  const { getTranslationText } = helpers;

  const signUp = () => {
    setLoading(true);
    dispatch(authActions.signUp(emailValue))
      .then((response) => {
        setLoading(false);
        if (response?.data.success) {
          closeAuthSidebar();
          Swal.fire({
            icon: 'info',
            title: getTranslationText('login.check_mail'),
            html: renderToString(
              <div className="auth-sidebar__alert">
                <p>
                  {getTranslationText('login.registr_letter')}
                  <span>{` ${emailValue}`}</span>
                </p>
                <p>
                  {getTranslationText('login.go_by_link')}
                </p>
                <p>
                  <span>{getTranslationText('login.attention')}</span>
                  {' '}
                  {getTranslationText('login.registr_on_bit')}
                  {' '}
                  <a href="https://bit.team/">
                    bit.team
                  </a>
                  {' '}
                  {getTranslationText('login.and_nowhere')}
                </p>
              </div>,
            ),
            confirmButtonText: getTranslationText('general.close'),
          });
        }
      });
  };

  const emailChangeHandler = useCallback((event) => { handleEmailValue(event.target.value); }, []);

  return (
    <div>
      {isLoading && <Preloader />}
      <div className="auth-sidebar__content__title">{getTranslationText('login.sign_up')}</div>
      <Input
        label={getTranslationText('login.email')}
        name="email"
        type="email"
        value={emailValue}
        onChange={emailChangeHandler}
      />
      <div className="auth-sidebar__footer">
        <div className="auth-sidebar__footer__item">
          {getTranslationText('login.already_mem')}
          <div onClick={() => { toggleSidebar(true); }}>{getTranslationText('general.sign_in')}</div>
        </div>
        <div className="auth-sidebar__footer__item">
          <button
            type="button"
            className="button primary auth-submit"
            onClick={signUp}
          >
            {getTranslationText('login.sign_up')}
          </button>
        </div>
      </div>
    </div>
  );
};

AuthSidebarSignUp.propTypes = {
  toggleSidebar: PropTypes.func.isRequired,
  closeAuthSidebar: PropTypes.func.isRequired,
};

export default AuthSidebarSignUp;
